<script setup>
import { PermissionNames } from "~/configs/permission_names";
import { useUsersStore } from "~/stores/usersStore";
const handleCloseDialog = () => {
  usersStore.setCreateModalVisibility(false);
};
const usersStore = useUsersStore();
</script>
<template>
  <div>
    <div
      v-if="isUserPermitted(PermissionNames.USER_CREATE)"
      class="cursor-pointer text-light-purple underline-light-purple- underline text-xs w-full flex justify-end dark:text-light-purple-bar"
      label="Add Agent"
      @click.prevent="usersStore.setCreateModalVisibility(true)"
    >
      <el-tooltip content="Add Agents" placement="top">
        <Svgs
          name="plus"
          class="w-5 h-5 text-light-sec-purple dark:text-white"
          stroke-width="1.2"
        />
      </el-tooltip>
    </div>
    <el-dialog
      v-model="usersStore.showUsersCreateModal"
      :before-close="handleCloseDialog"
      :lock-scroll="false"
      :modal="false"
      :show-close="true"
      :destroy-on-close="true"
      class="rounded-lg"
      draggable
      title="Create Agent"
      align-center
      width="35%"
    >
      <template #header="{ titleId, titleClass }">
        <div class="my-header flex flex-col gap-1">
          <h4 :id="titleId" class="text-md" :class="titleClass">
            Create Agent
          </h4>
        </div>
      </template>
      <div class="subtext-dialog">
        <UsersCreateForm :show-edit-modal-header="false"></UsersCreateForm></div
    ></el-dialog>
  </div>
</template>
